import { Injectable, PLATFORM_ID, NgZone } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { AngularFireStorage } from '@angular/fire/storage';
import { FirebaseAppConfig } from '@angular/fire';
import { Observable } from 'rxjs';
import { timestamp } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class AlarmsqueryService {
  array: any[] = [];
  alarmsCollection: AngularFirestoreCollection<Alarm>;
  alarms: Observable<Alarm[]>;
  telemetry: Telemetry[] = [];
  private _afs: AngularFirestore;
  private _afb: AngularFireDatabase;


  constructor(public afs: AngularFirestore, public afb: AngularFireDatabase, private zone: NgZone) {}

  public setupFirebase(config: FirebaseAppConfig, firebaseAppName: string){
    this._afs = new AngularFirestore(config, firebaseAppName, false, null, PLATFORM_ID, this.zone, null);
    this._afb = new AngularFireDatabase(config, firebaseAppName, config['databaseURL'], PLATFORM_ID, this.zone);
    //this._afS = new AngularFireStorage(config, firebaseAppName, config['databaseURL'], PLATFORM_ID, this.zone );
  }

  getAlarms(){
    return this._afs.collection('alarms', ref => ref.orderBy('timestamp', 'desc').limit(200)).valueChanges();
  }

  getAlarmsByTime(start, end){
    return this._afs.collection('alarms', ref => ref.where('timestamp', '>=', start)
                                                   .where('timestamp', '<=', end)
                                                   .orderBy('timestamp', 'desc')
                                                   ).valueChanges();
  }

  getAlarmsRT(){
    return this._afb.list('alarms').valueChanges();
  }

  getAlarmsRTid(id: string){
    this._afb.list('alarms/'+id).valueChanges().subscribe(result =>{
      this.array = [];
      result.forEach(element => {
        this.array.push(Object.values(element));
        return Object.values(element);
      });
    });
  }

  testService(){
    console.log('executed');
    return 'yep'
  }
  
  getOtherData(){
    return this._afs.collection('OtherData', ref => ref.orderBy('Fecha', 'desc')).valueChanges();
  }  
  
  listPlanillas()
  {
    return this._afs.doc(`Planillas/Planillas`).valueChanges();
  }

  getPredictData(){
    return this._afs.collection('proyections').valueChanges();
  }

  pushOtherData(fecha, site, gas, diesel, sales){
    const res = this._afs.collection('OtherData').add({
      Diesel: diesel,
      Fecha: fecha,
      Gas: gas,
      Place: site,
      Ventas: sales
    })
    console.log(res.then(result =>{
      const userRef: AngularFirestoreDocument<any> = this.afs.doc(`OtherData/${result.id}`);
      const data = {
        id: result.id
      }
      return userRef.update(data);
    }))

  }

  updateIOConfig(site, device, levas){
    console.log(site)
    let sub = this._afs.collection('places')
    .doc(site)
    .valueChanges().subscribe(result =>{
      console.log(result);
      let body = result['devices'];
      for(let io in body['IO'])
      {
        if(body['IO'][io]['bd_id'] == device)
        {
          body['IO'][io]['Levas'] = levas
        }
      }
      let part = "devices";
      this._afs.collection('places').doc(site).update({[part]: body})
      .then(() => {
        return 'ok'
      })
      .catch(function(error){
        console.error('Error: ', error)
        return -1
      })
      sub.unsubscribe();
    })
  }

  updateOtherData(fecha, site, gas, diesel, sales, id){
    const userRef: AngularFirestoreDocument<any> = this._afs.doc(`OtherData/${id}`);
    const data = {
      id: id,
      Diesel: diesel,
      Fecha: fecha,
      Gas: gas,
      Place: site,
      Ventas: sales
    }
    return userRef.update(data);
  }

  getAlarmsConfig(id){
    return this._afs.collection('places').doc(id).valueChanges();
  }

  delteOtherData(id){
    return this._afs.collection('OtherData').doc(id).delete();
  }

}

interface Telemetry{
  timestamp?: string;
  date?: string;
}

interface Alarm{
  id?: string;
  timestamp?: string;
  value?: string;
  desc?: string;
  type?: string;
  zona?: string;
  city?: string;
  office?: string;
  device?: string;
  usr?: string;
}
